import { render, staticRenderFns } from "./MatBed.vue?vue&type=template&id=65139a86"
import script from "./MatBed.vue?vue&type=script&lang=js"
export * from "./MatBed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports